import React from "react";
import { Link } from "react-scroll";
import { useNavigate } from "react-router-dom";

import Navbar from "./Navbar";
import Footer from "./Footer";
import Experts from "./Experts";

import "./ProductMaintenance.css";

import maintenanceImg from "./Maintainance.png";

import {
  FaShieldAlt,
  FaTools,
  FaServer,
  FaBug,
  FaSyncAlt,
  FaTachometerAlt,
} from "react-icons/fa";

export default function ProductMaintenance() {
  const navigate = useNavigate();

  const handleStartProject = () => {
    navigate("/", {
      state: {
        scrollTo: "contact",
      },
    });
  };

  return (
    <>
      <Navbar />

      {/* ================= HERO ================= */}

      <section className="pm-hero">

        <div className="pm-left">

          <span className="pm-tag">
            PRODUCT MAINTENANCE
          </span>

          <h1>
            Keep Your Software
            <br />
            <span>Reliable & Secure</span>
          </h1>

          <p>
            We help businesses maintain, monitor and continuously
            improve software products through proactive maintenance,
            security updates, bug fixes and performance optimization.
          </p>

          <div className="pm-features">

            <div>
              <FaShieldAlt />
              Security Updates
            </div>

            <div>
              <FaBug />
              Bug Fixing
            </div>

            <div>
              <FaServer />
              24×7 Monitoring
            </div>

            <div>
              <FaTools />
              Preventive Maintenance
            </div>

          </div>

          <div className="pm-buttons">

            <button
              className="pm-btn-primary"
              onClick={handleStartProject}
            >
              Request Maintenance
            </button>

            <Link
              to="experts"
              smooth={true}
              duration={700}
              offset={-80}
            >
              <button className="pm-btn-secondary">
                Talk To Our Experts
              </button>
            </Link>

          </div>

        </div>

        <div className="pm-right">

          <img
            src={maintenanceImg}
            alt="Software Maintenance"
          />

        </div>

      </section>

      {/* ================= ABOUT ================= */}

      <section className="pm-about">

        <div className="pm-about-image">

          <img
            src={maintenanceImg}
            alt="Maintenance"
          />

        </div>

        <div className="pm-about-content">

          <span className="pm-section-tag">
            SOFTWARE MAINTENANCE
          </span>

          <h2>
            Ensure Business Continuity
            <span> With Reliable Maintenance</span>
          </h2>

          <p>
            Our software maintenance services ensure that your
            applications continue to operate efficiently after
            deployment. We provide continuous improvements,
            security patches, feature enhancements and proactive
            monitoring to maximize system uptime.
          </p>

          <div className="pm-about-grid">

            <div className="pm-card">

              <FaBug className="pm-icon" />

              <div>

                <h3>Bug Resolution</h3>

                <p>
                  Rapid detection and resolution of software issues.
                </p>

              </div>

            </div>

            <div className="pm-card">

              <FaShieldAlt className="pm-icon" />

              <div>

                <h3>Security Updates</h3>

                <p>
                  Regular patches to protect against cyber threats.
                </p>

              </div>

            </div>

            <div className="pm-card">

              <FaSyncAlt className="pm-icon" />

              <div>

                <h3>Continuous Improvements</h3>

                <p>
                  Regular feature enhancements based on business needs.
                </p>

              </div>

            </div>

            <div className="pm-card">

              <FaTachometerAlt className="pm-icon" />

              <div>

                <h3>Performance Optimization</h3>

                <p>
                  Improve speed, scalability and overall stability.
                </p>

              </div>

            </div>

          </div>

        </div>

      </section>
            {/* ================= SERVICES ================= */}

      <section className="pm-services">

        <div className="section-heading">

          <span>OUR SERVICES</span>

          <h2>Software Maintenance Services</h2>

          <p>
            We keep your applications secure, stable and high-performing
            through proactive maintenance and continuous improvements.
          </p>

        </div>

        <div className="pm-services-grid">

          <div className="pm-service-card">

            <FaBug className="pm-service-icon" />

            <h3>Bug Fixing</h3>

            <p>
              Rapid identification and resolution of software defects
              to minimize downtime.
            </p>

          </div>

          <div className="pm-service-card">

            <FaShieldAlt className="pm-service-icon" />

            <h3>Security Patches</h3>

            <p>
              Protect applications against vulnerabilities with
              timely updates.
            </p>

          </div>

          <div className="pm-service-card">

            <FaSyncAlt className="pm-service-icon" />

            <h3>Version Upgrades</h3>

            <p>
              Upgrade frameworks, libraries and dependencies without
              disrupting business operations.
            </p>

          </div>

          <div className="pm-service-card">

            <FaTachometerAlt className="pm-service-icon" />

            <h3>Performance Optimization</h3>

            <p>
              Improve application speed, database performance and
              scalability.
            </p>

          </div>

          <div className="pm-service-card">

            <FaServer className="pm-service-icon" />

            <h3>Infrastructure Monitoring</h3>

            <p>
              Continuous monitoring to ensure maximum uptime and
              system reliability.
            </p>

          </div>

          <div className="pm-service-card">

            <FaTools className="pm-service-icon" />

            <h3>Application Support</h3>

            <p>
              Dedicated maintenance and technical support for
              mission-critical applications.
            </p>

          </div>

        </div>

      </section>
      {/* ================= MAINTENANCE PROCESS ================= */}

<section className="pm-process">

  <div className="section-heading">

    <span>OUR PROCESS</span>

    <h2>How We Maintain Your Software</h2>

    <p>
      Our structured maintenance process keeps your applications secure,
      stable and continuously improving.
    </p>

  </div>

  <div className="timeline">

    <div className="timeline-item">

      <div className="timeline-circle">
        1
      </div>

      <h3>Monitor</h3>

      <p>
        We continuously monitor application health, uptime and system
        performance.
      </p>

    </div>

    <div className="timeline-line"></div>

    <div className="timeline-item">

      <div className="timeline-circle">
        2
      </div>

      <h3>Analyze</h3>

      <p>
        Our engineers identify bottlenecks, bugs and potential risks
        before they affect users.
      </p>

    </div>

    <div className="timeline-line"></div>

    <div className="timeline-item">

      <div className="timeline-circle">
        3
      </div>

      <h3>Resolve</h3>

      <p>
        Fix bugs, deploy updates and implement security patches with
        minimal downtime.
      </p>

    </div>

    <div className="timeline-line"></div>

    <div className="timeline-item">

      <div className="timeline-circle">
        4
      </div>

      <h3>Optimize</h3>

      <p>
        Improve performance, scalability and reliability through
        continuous optimization.
      </p>

    </div>

  </div>

</section>
{/* ================= COMPANY STATS ================= */}

<section className="pm-stats">

  <div className="section-heading">

    <span>OUR IMPACT</span>

    <h2>Trusted By Businesses Worldwide</h2>

    <p>
      Delivering reliable software maintenance services backed by years
      of experience and proven customer success.
    </p>

  </div>

  <div className="pm-stats-grid">

    <div className="pm-stat-card">

      <h2>25+</h2>

      <h4>Years Experience</h4>

      <p>
        Delivering enterprise software solutions since 1998.
      </p>

    </div>

    <div className="pm-stat-card">

      <h2>500+</h2>

      <h4>Applications Maintained</h4>

      <p>
        Supporting business-critical applications across industries.
      </p>

    </div>

    <div className="pm-stat-card">

      <h2>99.9%</h2>

      <h4>System Uptime</h4>

      <p>
        Ensuring high availability through proactive maintenance.
      </p>

    </div>

    <div className="pm-stat-card">

      <h2>24×7</h2>

      <h4>Technical Support</h4>

      <p>
        Dedicated engineers available whenever you need assistance.
      </p>

    </div>

  </div>

</section>
{/* ================= CTA ================= */}

<section className="pm-cta">

  <h2>
    Keep Your Software Running at Its Best
  </h2>

  <p>
    Whether you need bug fixes, security updates, performance
    optimization or long-term application support, our maintenance
    experts are ready to help.
  </p>

  <div className="pm-cta-buttons">

    <button
      className="pm-btn-primary"
      onClick={handleStartProject}
    >
      Request Maintenance
    </button>

    <Link
      to="experts"
      smooth={true}
      duration={700}
      offset={-80}
    >
      <button className="pm-btn-secondary">
        Talk To Our Experts
      </button>
    </Link>

  </div>

</section>
    </>
  );
}